<template lang="pug">
  footer#footer
    .accent
      img#footer-accent(src="../assets/img/ppr-footer-border-accent.svg", draggable="false", alt="")
    .footer-wrapper
      .logo
        img(src="../assets/img/ppr-logo-reversed-logomark-200.svg", draggable="false", alt="")
      .footer-text
        nav.footer-nav
          router-link(v-for="(link, index) in settings.footer_links", :key="index", :to="link.footer_link_route") {{ link.footer_link_text }}
        p {{ settings.copyright_text }}
</template>

<script>
export default {
  props: ['settingsData'],
  computed: {
    settings: function () {
      return this.settingsData
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/helpers/mixins.styl'

footer
  background-color $green-tint
  border-top 2px solid $green
  color $white
  display flex
  height 13rem
  position relative
  width 100%
  .accent
    position absolute
    right 10%
    top -2.7rem
    #footer-accent
      height 85px
      max-width 85px
  .footer-wrapper
    align-items center
    display flex
    margin-left 230px
    mobile-width()
    nav
      a
        border-bottom 1px solid transparent
        color $white
        &:first-child
          margin-right 1rem
        &:hover
          color white
          border-bottom 1px solid white
        &.router-link-active
          font-weight bold
    p
      margin-top 1.2rem
    .logo
      margin-right 2rem
      max-width 100px
      width 100%

  @media (max-width: 657px)
    .accent
      display none

  @media (max-width: 483px)
    .footer-wrapper
      nav
        display flex
        flex-direction column
        a
          &:first-child
            margin-right 0
            margin-bottom 0.5rem
</style>
